/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import CalibrationHistoryIcon from '@/assets/icons/calibration-history.svg';
import CheckBox from '@/components/checkBox/CheckBox';
import {CALIBRATION_WIZARD_CONTENT, VOLUME_SENSOR_LABEL} from '@/constants/calibrationWizardConstant';
import {TARE_STAGE_ENUM} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog, consoleError} from '@/libs/consoleHelper';

import BottomMenu from '../menu/bottommenu/BottomMenu.jsx';

import {
  FactoryResetCalibration,
  DoTare,
  IsTareDone,
} from './calibrationLoadCellHistory/data/CalibrationHistoryData.jsx';
import WelcomeContent from './components/Welcome.jsx';

import './CalibrationLoadCellSensor.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  isPCRunning: store.setupStore.isPCRunning,
  licenseStatus: store.deviceInfoStore.licenseStatus,
  licenseType: store.deviceInfoStore.licenseType,
}))
class CalibrationLoadCellSensor extends Component {
  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.CALIBRATION_LOAD_CELL_SENSOR));
    let enableNextButton = true;
    if (this.props.isPCRunning) {
      enableNextButton = false;
    }
    this.setupTopMenuProperties(enableNextButton);
  }

  componentWillUnmount() {
    this.props.dispatch(setupActions.topButtonSecondaryProperties(undefined));
  }

  setupTopMenuProperties = (isButtonActive, showSecondaryButton, disableSecondarButton) => {
    const {licenseStatus, licenseType} = this.props;
    const isDemoMode = !(
      (licenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
        licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
      licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
    );

    // eslint-disable-next-line no-param-reassign
    disableSecondarButton = disableSecondarButton === undefined ? false : disableSecondarButton;
    const button1Properties = {
      id: APPDATA.RESET,
      label: APPDATA.RESET.toUpperCase(),
      onClick: this.onClickResetDefault,
      // disabled: !isButtonActive
      disabled: isDemoMode,
      className: ' infoButton ', // not-visibile-div
    };
    const button2Properties = {
      id: APPDATA.CALIBRATION_HISTORY,
      label: APPDATA.CALIBRATION_HISTORY,
      onClick: this.onClickCalibrationHistory,
      // disabled: !isButtonActive
      disabled: false,
      className: ' save-button ',
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backToHomePage,
      // onClick: this.backAction,
    };
    // var titleMenuProperties = APPDATA.CALIBRATION_LOAD_CELL_SENSOR;
    const titleMenuProperties = APPDATA.SYSTEM_SETTING;
    const calibrationHistoryButton = showSecondaryButton
      ? {
          id: 'CalibrationHistory',
          onClick: this.onClickCalibrationHistory,
          className: 'calibrationHistoryButton',
          icon: CalibrationHistoryIcon,
          disabled: disableSecondarButton,
        }
      : undefined;
    // this.setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties, calibrationHistoryButton)
    this.setDoubleTopMenuProperties(
      button1Properties,
      button2Properties,
      backButtonProperties,
      titleMenuProperties,
      calibrationHistoryButton,
    );
  };

  // backAction = () => {
  //   const popUpButton = [
  //     {
  //       id: APPDATA.YES,
  //       isPrimaryButton: true,
  //       onClick: this.onClickPopUpBackButton,
  //       label: APPDATA.YES,
  //     },
  //     {
  //       id: APPDATA.NO,
  //       isPrimaryButton: false,
  //       onClick: this.onClickPopUpBackButton,
  //       label: APPDATA.NO,
  //     },
  //   ];
  //   this.props.dispatch(
  //     modalActions.showPopUp({
  //       popUpTitle: 'Calibration Wizard',
  //       popUpText: (
  //         <div>
  //           You are about to exit Calibration Wizard.
  //           <br />
  //           Do you want to continue?
  //         </div>
  //       ),
  //       popUpQuestion: undefined,
  //       popUpButton,
  //     }),
  //   );
  // };

  // onClickPopUpBackButton = (e) => {
  //   switch (e.currentTarget.id) {
  //     case APPDATA.QUIT:
  //       break;
  //     case APPDATA.YES:
  //       this.backToHomePage();
  //       break;
  //     case APPDATA.NO:
  //       break;
  //     case APPDATA.CONTINUE:
  //       break;
  //     default:
  //       break;
  //   }
  //   this.props.dispatch(modalActions.hidePopUp());
  // };

  // TODO : refactor using hook
  // eslint-disable-next-line class-methods-use-this
  backToHomePage = () => {
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  // TODO : refactor using hook
  // setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties, calibrationHistoryButton) => {
  //   this.props.dispatch(
  //     setupActions.setTopMenuProperties({
  //       topButtonProperties:
  //         topButtonProperties === undefined
  //           ? undefined
  //           : {
  //               id: topButtonProperties.id,
  //               label: topButtonProperties.label,
  //               disabled: topButtonProperties.disabled,
  //               onClick: topButtonProperties.onClick,
  //             },
  //       backButtonProperties:
  //         backButtonProperties === undefined
  //           ? undefined
  //           : {
  //               id: backButtonProperties.id,
  //               label: backButtonProperties.label,
  //               disabled: backButtonProperties.disabled,
  //               onClick: backButtonProperties.onClick,
  //             },
  //       titleMenuProperties,
  //       topButtonSecondaryButtonProperties: calibrationHistoryButton,
  //     }),
  //   );
  //   this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  // };

  setDoubleTopMenuProperties = (
    button1Properties,
    button2Properties,
    backButtonProperties,
    titleMenuProperties,
    calibrationHistoryButton,
  ) => {
    this.props.dispatch(
      setupActions.setDoubleTopMenuProperties({
        button1Properties:
          button1Properties === undefined
            ? undefined
            : {
                id: button1Properties.id,
                label: button1Properties.label,
                onClick: button1Properties.onClick,
                disabled: button1Properties.disabled,
                className: button1Properties.className,
              },
        button2Properties:
          button2Properties === undefined
            ? undefined
            : {
                id: button2Properties.id,
                label: button2Properties.label,
                onClick: button2Properties.onClick,
                disabled: button2Properties.disabled,
                className: button2Properties.className,
              },
        backButtonProperties: {
          id: backButtonProperties.id,
          label: '',
          disabled: backButtonProperties.disabled,
          onClick: backButtonProperties.onClick,
        },
        titleMenuProperties,
        topButtonSecondaryButtonProperties: calibrationHistoryButton,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  // eslint-disable-next-line class-methods-use-this
  onClickCalibrationHistory = () => {
    consoleLog(`${APPDATA.CALIBRATION_HISTORY} Clicked`);
    window.location.href = APPDATA.CALIBRRATION_HISTORY_ADRESS;
  };

  onClickResetDefault = () => {
    consoleLog(`${APPDATA.RESET_DEFAULT} Clicked`);
    // this.tubeAttached(false);
    this.resetCalibrationConfirmation();
    // var popUpButton = [{
    //     id: APPDATA.OK,
    //     isPrimaryButton: true,
    //     onClick: this.onClickSubmitConfirmation,
    //     label: APPDATA.OK,
    // },
    // {
    //     id: APPDATA.CANCEL,
    //     isPrimaryButton: false,
    //     onClick: this.onClickSubmitConfirmation,
    //     label: APPDATA.CANCEL
    // }]
    // this.props.dispatch(modalActions.showPopUp({
    //     popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TITLE,
    //     popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TEXT,
    //     popUpButton: popUpButton,
    // }))
  };

  tubeAttached(isTubeDetached) {
    const popUpButton = [
      {
        id: APPDATA.OK,
        isPrimaryButton: true,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.OK,
        disabled: !isTubeDetached,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.CANCEL,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TITLE,
        popUpText: (
          <div>
            <div
              className=""
              style={{marginBottom: '25px'}}
            >
              {APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TEXT}
            </div>
            <CheckBox
              id="tube_detached_checkbox"
              onChange={this.toggleCheckboxValue}
              value={isTubeDetached}
              defaultChecked={isTubeDetached}
              text={APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.CHECKBOX} // v
            />
          </div>
        ),
        popUpButton,
      }),
    );
  }

  toggleCheckboxValue = (e) => {
    const isTubeDetached = e.currentTarget.checked;
    this.tubeAttached(isTubeDetached);
  };

  onClickSubmitConfirmation = async (e) => {
    this.props.dispatch(modalActions.hidePopUp());
    switch (e.currentTarget.id) {
      case APPDATA.OK:
        await this.CallDoTare();
        // var setCalibration = await this.FactoryResetCalibration()
        // consoleLog("RESET DEFAULT", setCalibration)
        // if (setCalibration) {
        //     // this.props.dispatch(setupActions.showAlert({
        //     //     alertShow: true,
        //     //     alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.SUCCESS_RESET_DEFAULT,
        //     //     alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS
        //     // }));
        //     var popUpButton = [{
        //         id: APPDATA.FIELD_NAME.CHECK_SCALES,
        //         isPrimaryButton: true,
        //         onClick: this.onClickSubmitConfirmation,
        //         label: APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase(),
        //         className: "calibrationHistoryPopupButton "
        //     }, {
        //         id: APPDATA.CLOSE,
        //         isPrimaryButton: false,
        //         onClick: this.onClickSubmitConfirmation,
        //         label: APPDATA.CLOSE.toUpperCase(),
        //         // className: "calibrationHistoryPopupButton "
        //     }]
        //     this.props.dispatch(modalActions.showPopUp({
        //         popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TITLE,
        //         popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.SUCCESS_RESET_DEFAULT,
        //         popUpButton: popUpButton,
        //     }))
        // }
        // else {
        //     this.props.dispatch(setupActions.showAlert({
        //         alertShow: true,
        //         alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.FAILED_RESET_DEFAULT,
        //         alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER
        //     }));
        // }
        break;
      case APPDATA.CANCEL:
        break;
      case APPDATA.FIELD_NAME.CHECK_SCALES:
        window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CHECK_SCALE_ADDRESS;
        break;
      case APPDATA.CLOSE:
        break;
      default:
        break;
    }
  };

  // eslint-disable-next-line consistent-return
  async CallDoTare() {
    try {
      const tareStage = {
        Stage: TARE_STAGE_ENUM.Reset,
      };
      const isTareSuccess = await DoTare(tareStage);
      let successCount = 0;
      const tareStatusCheck = [];
      if (isTareSuccess[VOLUME_SENSOR_LABEL.Protein] === true) {
        tareStatusCheck.push(APPDATA.KEY.ProteinTube);
        successCount += 1;
      }
      if (isTareSuccess[VOLUME_SENSOR_LABEL.Buffer] === true) {
        tareStatusCheck.push(APPDATA.KEY.BufferTube);
        successCount += 1;
      }
      if (successCount === 2) {
        consoleLog('CallDoTare', {state: this.state, isTareSuccess});
        this.setState({
          isCallDoTareSuccess: true,
        });
        this._isTareDonePooling = await this.poolingIsTareDone(tareStatusCheck);
      } else {
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.TARE_FAILED_TEXT,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        // this._bus.publish("SET_TOPMENU_COMPLATE", STEP_WIZARD.NoTubeCalibration)
      }
      return isTareSuccess;
    } catch (error) {
      consoleError('[DoTare] -', error);
    }
  }

  poolingIsTareDone = (tareStatusCheck) => {
    const tareDoneId = setInterval(async () => {
      await this.GetIsTareDone(tareStatusCheck);
    }, 300);

    return tareDoneId;
  };

  // eslint-disable-next-line consistent-return
  async GetIsTareDone(tareStatusCheck) {
    try {
      const IstareDoneStatus = await IsTareDone();
      let totalDone = 0;
      let totaltrue = 0;
      let totalfalse = 0;
      tareStatusCheck.forEach((value) => {
        if (IstareDoneStatus[value].IsDone === true) {
          totalDone += 1;
          if (IstareDoneStatus[value].IsAboveFailureThreshold) totalfalse += 1;
          else totaltrue += 1;
        }
      });
      consoleLog('GetIsTareDone', {state: this.state, IstareDoneStatus});
      if (totalDone === tareStatusCheck.length) {
        this.setState({
          isTareDone: true,
        });
        if (totalfalse > 0) {
          this.setState({
            isTareSuccess: false,
          });
          if (typeof this._isTareDonePooling !== 'undefined') clearInterval(this._isTareDonePooling);
          this.props.dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.FAILED_LOAD_CALIBRATION,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        }
        if (totaltrue === tareStatusCheck.length) {
          if (typeof this._isTareDonePooling !== 'undefined') clearInterval(this._isTareDonePooling);
          this.setState(
            {
              isTareSuccess: true,
            },
            async () => {
              if (this.state.isCallDoTareSuccess && this.state.isTareDone && this.state.isTareSuccess) {
                const setCalibration = await this.FactoryResetCalibration();
                consoleLog('setCalibration', setCalibration);
                if (setCalibration) {
                  // this.props.dispatch(setupActions.showAlert({
                  //     alertShow: true,
                  //     alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION,
                  //     alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS
                  // }));
                  const popUpButton = [
                    {
                      id: APPDATA.FIELD_NAME.CHECK_SCALES,
                      isPrimaryButton: true,
                      onClick: this.onClickSubmitConfirmation,
                      label: APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase(),
                      className: 'calibrationHistoryPopupButton ',
                    },
                    {
                      id: APPDATA.CLOSE,
                      isPrimaryButton: false,
                      onClick: this.onClickSubmitConfirmation,
                      label: APPDATA.CLOSE.toUpperCase(),
                      // className: "calibrationHistoryPopupButton "
                    },
                  ];
                  this.props.dispatch(
                    modalActions.showPopUp({
                      popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TITLE,
                      popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.SUCCESS_RESET_DEFAULT,
                      popUpButton,
                    }),
                  );
                } else {
                  this.props.dispatch(
                    setupActions.showAlert({
                      alertShow: true,
                      alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.FAILED_RESET_DEFAULT,
                      alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
                    }),
                  );
                }
              } else {
                this.props.dispatch(
                  setupActions.showAlert({
                    alertShow: true,
                    alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.FAILED_RESET_DEFAULT,
                    alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
                  }),
                );
              }
            },
          );
        }
      }
      return IstareDoneStatus;
    } catch (error) {
      consoleError('[DoTare] -', error);
    }
  }

  resetCalibrationConfirmation() {
    const popUpButton = [
      {
        id: APPDATA.RESET,
        isPrimaryButton: true,
        onClick: () => this.SetCalibrationReset(),
        label: APPDATA.RESET,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.CANCEL,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TITLE,
        popUpText: (
          <div>
            <div
              className=""
              style={{marginBottom: '25px'}}
            >
              {APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TEXT}
            </div>
          </div>
        ),
        popUpButton,
      }),
    );
  }

  async SetCalibrationReset() {
    try {
      const setCalibration = await this.FactoryResetCalibration();
      consoleLog('setCalibration', setCalibration);
      if (setCalibration) {
        // this.props.dispatch(setupActions.showAlert({
        //     alertShow: true,
        //     alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION,
        //     alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS
        // }));
        const popUpButton = [
          {
            id: APPDATA.FIELD_NAME.CHECK_SCALES,
            isPrimaryButton: true,
            onClick: this.onClickSubmitConfirmation,
            label: APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase(),
            className: 'calibrationHistoryPopupButton ',
          },
          {
            id: APPDATA.CLOSE,
            isPrimaryButton: false,
            onClick: this.onClickSubmitConfirmation,
            label: APPDATA.CLOSE.toUpperCase(),
            // className: "calibrationHistoryPopupButton "
          },
        ];
        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.TITLE,
            popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.SUCCESS_RESET_DEFAULT,
            popUpButton,
          }),
        );
      } else {
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RESET_DEFAULT.FAILED_RESET_DEFAULT,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
      }
    } catch (error) {
      consoleError('[DoTare] -', error);
    }
  }

  // eslint-disable-next-line class-methods-use-this, consistent-return
  async FactoryResetCalibration() {
    try {
      const data = FactoryResetCalibration();
      return data;
    } catch (error) {
      consoleError('[FactoryResetCalibration] -', error);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onClickCheckOrCalibrateScale = (i) => {
    switch (i) {
      case CALIBRATION_WIZARD_CONTENT.CheckScales:
        window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CHECK_SCALE_ADDRESS;
        break;
      case CALIBRATION_WIZARD_CONTENT.CalibrateScale:
        window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CALIBRATE_SCALE_ADDRESS;
        break;
      default:
        break;
    }
  };

  render() {
    const style = {
      constraint: {
        fontSize: this.props.fontSize,
      },
    };
    const {licenseStatus, licenseType} = this.props;
    const isDemoMode = !(
      (licenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
        licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
      licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
    );

    return (
      <div
        className="div-2row"
        style={style.constraint}
      >
        {/* {showCalibrationLoadCellSensor[this.state.activeCalibrationStep]} */}
        <WelcomeContent
          onClickCheckOrCalibrateScale={this.onClickCheckOrCalibrateScale}
          isDemoMode={isDemoMode}
        />
        ,
        <BottomMenu />
      </div>
    );
  }
}

export default CalibrationLoadCellSensor;
